import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { HistoryChangeItem } from '../../../models/history-change-item';

const apiServer = environment.apiServer;

@Component({
  selector: 'app-modal-history-change',
  templateUrl: './modal-history-change.component.html',
  styleUrls: ['./modal-history-change.component.sass']
})
export class ModalHistoryChangeComponent implements OnInit {
  http: HttpClient;

  dataHistoryChange: Array<HistoryChangeItem>;
  
  constructor(private _http: HttpClient) {
    this.http = _http;
  }

  ngOnInit() {
    $('#modalHistoryChangeComponent').on('show.bs.modal', function () {
      $('#modalAuctionDetail').css({'z-index': 1030});
    })

    $('#modalHistoryChangeComponent').on('hidden.bs.modal', function () {
      $('#modalAuctionDetail').css({'z-index': 1041});
    })
  }

  
  public loadHistoryChange(IDAuction){
    this.dataHistoryChange = new Array<HistoryChangeItem>();
    // this.dataHistoryChange[0] = { number: "1", action:"Изменение строки", autor:"Иван Иванов", date:"10.10.2000" }
    // this.dataHistoryChange[1] = { number: "2", action:"Изменение строки", autor:"Иван Иванов", date:"10.10.2001" }
    // this.dataHistoryChange[2] = { number: "3", action:"Изменение строки", autor:"Иван Иванов", date:"10.10.2003" }
    //commercial_offer/changeHistory/{IDAuction}

    this.http.get<Array<string>>(apiServer + "/commercial_offer/changeHistory/" + IDAuction)
    .subscribe(resp => { 
      for (let index = 0; index < resp.length; index++) {
        this.dataHistoryChange[index] = { number: resp[index]['number'], action:resp[index]['action'], autor:resp[index]['autor'], date:resp[index]['date'] }; 
      }
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-detail/modal-history-change/modal-history-change.component.ts